import Collection from "../collection";
import Task from "../model/task";

import { hashify } from "../utils/arrays";





export default Collection.extend( {
    endpoint: 'tasks/list/with-comments?apiVersion=2.1&sortBy=id&sortDirection=DESC&limit=7',
    responseAt: 'items',
    countAt: 'total',
    model: Task,
    parseResponse(modelsAttrs, { active_id, schedules }) {
        schedules = hashify( schedules, schedule => [schedule.id, schedule] );

        return modelsAttrs.map( ({ comments, task, capabilities, ...attrs }) => {
            const taskAttrs = { 
                id: task.id,
                task,
                schedule: schedules[task.schedule_id],
                capabilities, 
                ...attrs };

            if (task.id != active_id)
                taskAttrs.lastComment = comments[0];
            else
                taskAttrs.comments = comments;

            return taskAttrs;
        } );
    }
}, {

    getHttpFilters(tasksModuleState) {
        const { filters, activeId, } = tasksModuleState;
        const { assigned_status, category_id, news_type_id, confirmed,
            assigned_organization_id, assigned_user_id,
            contract_id, organization_id,
            title, } = filters;
        
        const result = {};
        if (+assigned_organization_id > 0) result.assignedOrganizationId = assigned_organization_id;
        if (+assigned_user_id > 0) result.assignedUserId = assigned_user_id;
        if (+organization_id > 0) result.organizationId = organization_id;
        if (+contract_id > 0) result.contractId = contract_id;
        if (assigned_status) result.onlyStatus = assigned_status;
        if (category_id) result.category_id = category_id;
        if (news_type_id) result.type_id = news_type_id;
        if (confirmed) result.confirmed = confirmed;
        if (title) result.search = title;
        if (activeId) result.id = activeId;
                
        return result;
    }
    
} );


// WEBPACK FOOTER //
// ./src/js/collection/tasks.js